<template>
  <div class="multipleSelectScroll">
    <el-col :xs="24" :md="12" :lg="6">
      <el-form-item :label="deptLabel" :prop="deptIdField">
        <el-cascader style="width: 100%"
                     v-model="formParam[deptIdField]"
                     :options="deptOptions"
                     :show-all-levels="false"
                     :props="{ value:'id', multiple: deptMultiple, checkStrictly: true, emitPath: false }"
                     @change="deptSelect"
                     filterable :clearable="deptClearable">
        </el-cascader>
      </el-form-item>
    </el-col>
    <el-col :xs="24" :md="12" :lg="6">
      <el-form-item :label="userLabel" :prop="userIdField">
        <el-select v-model="formParam[userIdField]" :clearable="userClearable" filterable :multiple="userMultiple"
                   placeholder="请选择" style="width: 100%">
          <el-option v-for="item in userOptions" :key="item.userId" :label="item.nickName+'（'+item.phonenumber+'）'"
                     :value="item.userId"/>
        </el-select>
      </el-form-item>
    </el-col>
  </div>
</template>

<script>
import {treeselect, treeSelectWithOutDataScope} from "@/api/system/dept";
import {listUser, listUserWithOutDataScope} from "@/api/system/user";
import {mapState} from "vuex";

export default {
  name: "deptUserSelect",
  props: {
    formParam: {},
    authCheck: { // 是否需要控制权限
      type: Boolean,
      default: true
    },
    deptMultiple: {
      type: Boolean,
      default: true
    },
    userMultiple: {
      type: Boolean,
      default: true
    },
    deptClearable: {
      type: Boolean,
      default: true
    },
    userClearable: {
      type: Boolean,
      default: true
    },
    autoSelectDept: { // 进入页面时，是否选中部门
      type: Boolean,
      default: false
    },
    autoSelectUser: { // 进入页面时，是否选中负责人
      type: Boolean,
      default: true
    },
    deptLabel: {
      type: String,
      default: '部门'
    },
    userLabel: {
      type: String,
      default: '负责人'
    },
    deptIdField: {
      type: String,
      default: 'deptIdList'
    },
    userIdField: {
      type: String,
      default: 'managerIdList'
    }
  },
  data () {
    return {
      deptOptions: [],
      userOptions: []
    };
  },
  components: {
  },
  mounted () {
    this.getTreeselect()
    this.queryUserList(this.formParam[this.deptIdField])
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      dept: state => state.user.dept,
      userDataScope: state => state.user.userDataScope
    })
  },
  methods: {
    /** 查询部门下拉树结构 */
    getTreeselect () {
      if (this.authCheck) {
        treeselect().then(response => {
          this.getDeptOptions(response)
          this.autoSelectDeptMethod()
        });
      } else {
        treeSelectWithOutDataScope().then(response => {
          this.getDeptOptions(response)
          this.autoSelectDeptMethod()
        });
      }
    },
    getDeptOptions (response) {
      // 去掉顶级部门
      if (response.data && response.data.length > 0 && response.data[0].parentId === 0) {
        this.deptOptions = response.data[0].children
      } else {
        this.deptOptions = response.data
      }
    },
    autoSelectDeptMethod () {
      if (this.autoSelectUser) {
        // 进入页面时选择用户所在部门
        if (this.deptMultiple) {
          this.formParam[this.deptIdField] = [this.dept.deptId]
        } else {
          this.formParam[this.deptIdField] = this.dept.deptId
        }
      }
    },
    queryUserList (value) {
      this.userOptions = []
      let param = {}
      if (this.deptMultiple && value.length) {
        if (value.length > 0) {
          param = {deptIdList: value.join(',')}
        }
      } else {
        param = {deptId: this.dept.deptId}
      }
      if (this.authCheck) {
        listUser(param).then(response2 => {
          this.userOptions = response2.rows;
          this.autoSelectUserMethod()
        });
      } else {
        listUserWithOutDataScope(param).then(response2 => {
          this.userOptions = response2.rows;
          this.autoSelectUserMethod()
        });
      }
    },
    autoSelectUserMethod () {
      if (this.autoSelectUser) {
        if (this.userMultiple) {
          this.formParam[this.userIdField] = [this.currentUserId]
        } else {
          this.formParam[this.userIdField] = this.currentUserId
        }
      }
      this.$emit('auto-selected') // 首次进入默认选中后
    },
    deptSelect (value) {
      this.formParam[this.userIdField] = null
      this.queryUserByDept
      this.userOptions = []
      let param = {}
      if (this.deptMultiple) {
        if (value) {
          param = {deptIdList: value.join(',')}
        }
      } else {
        param = {deptId: value}
      }
      if (this.authCheck) {
        listUser(param).then(response => {
          this.userOptions = response.rows;
        });
      } else {
        listUserWithOutDataScope(param).then(response => {
          this.userOptions = response.rows;
        });
      }
    },
  }
};
</script>
